import { useCallback } from "react";

import ModalMotion, {
  AnimateDirection,
} from "@/components/Molecules/ModalMotion";

import BookTrialClassForm from "../BookTrialClassForm";

import { classNameGenerator } from "@/utils";

import { useAppDispatch, useAppSelector } from "@/hooks";
import * as actions from "@/redux/BootCampReducer";

import styles from "./BookTrialClassModal.module.scss";

interface BookTrialClassModalProps {}

const BookTrialClassModal: React.FC<BookTrialClassModalProps> = () => {
  const dispatch = useAppDispatch();

  const cls = classNameGenerator(styles);

  const { showBookTrialClassModal } = useAppSelector((state) => state.bootCamp);

  const setShowBookTrialClassModal = useCallback(
    (value: any) => {
      dispatch(actions.setShowBookTrialClassModal(value));
    },
    [dispatch]
  );

  return showBookTrialClassModal ? (
    <ModalMotion
      overlayClosable
      onClose={() => setShowBookTrialClassModal(false)}
      width="520px"
      animateDirection={AnimateDirection.CENTER}
      borderRadius="10px"
      showClose
      iconTopPosition="20px"
      iconRightPosition="20px"
      className={cls("bookTrialClassModal")}
    >
      <BookTrialClassForm />
    </ModalMotion>
  ) : (
    <></>
  );
};

export default BookTrialClassModal;
